import React from "react";
import { Link } from "react-router-dom";
import { Globalalert, Navbar, Footer, Contact, ReturnToRecipes } from '../../components'

import recipesList from '../../data/recipesList';

import "./Recipes.css"

function RecipesPage() {
    
    return (
        <div id="recipes-page" className="site">
            <Navbar primaryColor="#000000"/>
            
            <ul className="recipes-list">
                {Object.entries(recipesList).map(([slug, recipe]) => (
                    <li className="recipe-item" key={slug}>
                    <Link to={`/recipes/${slug}`} className="recipe-link">
                        <img className="recipe-image" src={`https://img.youtube.com/vi/${recipe.youtubeID}/hq720.jpg`} alt={recipe.title} />
                        <h2 className="recipe-header">{recipe.title}</h2>
                        <h3 className="recipe-created-date">{recipe.date}</h3>
                    </Link>
                    </li>
                ))}
            </ul>

            <Contact />
        </div>
    );
}

export default RecipesPage;
